document.addEventListener('click',async e=>{const menu=e.target.closest('[data-menu-toggle]');if(menu){document.querySelector('.nav')?.classList.toggle('open');menu.setAttribute('aria-expanded',String(document.querySelector('.nav')?.classList.contains('open')))}if(e.target.closest('[data-cart-open]')){e.preventDefault();openCart()}if(e.target.closest('[data-cart-close]'))closeCart();const add=e.target.closest('[data-quick-add]');if(add){e.preventDefault();await addToCart(add.dataset.quickAdd,1)}});document.addEventListener('submit',async e=>{if(e.target.matches('[data-product-form]')){e.preventDefault();const f=e.target;await addToCart(new FormData(f).get('id'),Number(new FormData(f).get('quantity')||1))}});async function addToCart(id,quantity){if(!id)return;try{const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:Number(id),quantity})});if(!r.ok)throw Error('Could not add item');await openCart()}catch(err){alert(err.message)}}async function openCart(){document.querySelector('.cart-drawer')?.classList.add('open');document.querySelector('.cart-drawer')?.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';await refreshCart();document.querySelector('.eu-cart-close')?.focus()}function closeCart(){document.querySelector('.cart-drawer')?.classList.remove('open');document.querySelector('.cart-drawer')?.setAttribute('aria-hidden','true');document.body.style.overflow=''}async function refreshCart(){
 const target=document.querySelector('[data-cart-lines]');if(!target)return;
 try{
  const root=window.Shopify?.routes?.root||'/';
  const r=await fetch(root+'cart.js',{credentials:'same-origin'});
  if(!r.ok)throw Error('Cart could not be loaded');
  const cart=await r.json();
  target.innerHTML=cart.items.length?cart.items.map(i=>{
   const image=i.featured_image?.url||i.image||'';
   const option=i.variant_title&&i.variant_title!=='Default Title'?`<small>${escapeHtml(i.variant_title)}</small>`:'';
   return `<article class="eu-cart-item">
     ${image?`<img src="${escapeHtml(image)}" alt="${escapeHtml(i.product_title)}" loading="lazy">`:''}
     <div class="eu-cart-item-info">
       <strong>${escapeHtml(i.product_title)}</strong>${option}
       <span>${formatMoney(i.final_line_price)}</span>
       <div class="eu-cart-item-controls">
         <div class="eu-cart-qty"><button type="button" data-eu-cart-change="${escapeHtml(i.key)}" data-eu-cart-qty="${i.quantity-1}" aria-label="Decrease quantity">−</button><span>${i.quantity}</span><button type="button" data-eu-cart-change="${escapeHtml(i.key)}" data-eu-cart-qty="${i.quantity+1}" aria-label="Increase quantity">+</button></div>
         <button type="button" class="eu-cart-remove" data-eu-cart-change="${escapeHtml(i.key)}" data-eu-cart-qty="0">Remove</button>
       </div>
     </div></article>`;
  }).join(''):`<div class="eu-cart-empty"><span aria-hidden="true">♡</span><h3>Your bag is waiting</h3><p>Find your everyday comfort with Eunali.</p></div>`;
  document.querySelector('[data-cart-total]').textContent=formatMoney(cart.total_price);
  document.querySelector('[data-eu-drawer-count]').textContent=String(cart.item_count);
  document.querySelectorAll('[data-cart-count]').forEach(n=>n.textContent=cart.item_count);
 }catch(e){target.textContent='Unable to load your bag. Please try again.';}
}
function formatMoney(c){return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(c/100)}function escapeHtml(s){return String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]))}document.addEventListener('click',async e=>{const b=e.target.closest('[data-remove-line]');if(!b)return;await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:b.dataset.removeLine,quantity:0})});refreshCart()});document.addEventListener('keydown',e=>{if(e.key==='Escape')closeCart()});
document.addEventListener('click',e=>{if(e.target.closest('[data-scroll-product]'))document.querySelector('[data-product-form]')?.scrollIntoView({behavior:'smooth',block:'center'})});

// Eunali V4 product enhancements: correct selected-variant price, quantity, buy now, thumbnails.
document.addEventListener('click', function(e) {
 const qtyButton=e.target.closest('[data-eu-qty-minus],[data-eu-qty-plus]');
 if(qtyButton){const form=qtyButton.closest('form');const input=form?.querySelector('input[name="quantity"]');if(input){input.value=Math.max(1,Number(input.value||1)+(qtyButton.hasAttribute('data-eu-qty-plus')?1:-1));input.dispatchEvent(new Event('input',{bubbles:true}));}}

});
document.addEventListener('change',function(e){
 if(e.target.matches('.eu-product-purchase input[name="id"]')){
  const price=e.target.dataset.variantPrice;
  const panel=e.target.closest('.eu-product-purchase');
  if(price){const p=panel?.querySelector('[data-product-price]');if(p)p.textContent=price;const sticky=document.querySelector('[data-eu-sticky-price]');if(sticky)sticky.textContent=price;}
 }
});
document.addEventListener('submit',function(e){
 const btn=e.submitter;
 if(!e.target.matches('[data-product-form]')||!btn?.matches('[data-eu-buy-now]'))return;
 e.preventDefault();e.stopImmediatePropagation();
 const form=e.target, variant=form.querySelector('input[name="id"]:checked')||form.querySelector('input[name="id"]');
 if(!variant?.value)return;
 const quantity=Math.max(1,Number(form.querySelector('input[name="quantity"]')?.value||1));
 btn.disabled=true;
 fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:Number(variant.value),quantity})})
 .then(r=>{if(!r.ok)throw new Error('Unable to add this item. Please try again.');window.location.href=(window.Shopify?.routes?.root||'/')+'checkout';})
 .catch(err=>{alert(err.message);btn.disabled=false;});
},true);

/* Eunali V6 gallery: scoped per product section; supports Shopify theme editor reload. */
(function(){
 function initGallery(root){
  if(root.dataset.euGalleryReady==='true')return;
  root.dataset.euGalleryReady='true';
  const stage=root.querySelector('[data-eu-gallery-stage]'), main=root.querySelector('[data-gallery-main]'), thumbs=[...root.querySelectorAll('[data-eu-gallery-thumb]')];
  if(!stage||!main||!thumbs.length)return;
  let current=Math.max(0,thumbs.findIndex(b=>b.getAttribute('aria-current')==='true'));
  let ticket=0;
  const speed=Number(root.dataset.gallerySpeed)||350;
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function select(index){
   const next=(index+thumbs.length)%thumbs.length,thumb=thumbs[next];
   if(next===current && main.currentSrc && !main.dataset.galleryLoading)return;
   const url=thumb.dataset.galleryImage;
   const alt=thumb.dataset.galleryAlt||'';
   const seq=++ticket;
   const loader=new Image();loader.src=url;
   root.dataset.galleryLoading='true';
   const commit=()=>{
    if(seq!==ticket)return;
    const animate=!reduce&&root.dataset.transition!=='none';
    const change=()=>{
     if(seq!==ticket)return;
     main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=url;main.alt=alt;
     current=next;
     thumbs.forEach((b,i)=>{b.setAttribute('aria-pressed',String(i===next));if(i===next)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current')});
     const counter=root.querySelector('[data-eu-gallery-counter]');if(counter)counter.textContent=(next+1)+' / '+thumbs.length;
     if(window.matchMedia('(max-width: 749px)').matches){
       const rail=thumb.closest('.eu-gallery-thumbnails');
       if(rail){const left=thumb.offsetLeft-rail.offsetLeft;const right=left+thumb.offsetWidth;
         if(left<rail.scrollLeft||right>rail.scrollLeft+rail.clientWidth)rail.scrollTo({left:Math.max(0,left-8),behavior:reduce?'auto':'smooth'});}
     }
     stage.classList.remove('eu-gallery-changing');stage.classList.add('eu-gallery-entering');
     setTimeout(()=>stage.classList.remove('eu-gallery-entering'),speed);
     delete root.dataset.galleryLoading;
    };
    if(animate){stage.classList.add('eu-gallery-changing');setTimeout(change,Math.min(speed/2,220));}else change();
   };
   if(loader.complete)commit();else{loader.onload=commit;loader.onerror=()=>{delete root.dataset.galleryLoading;};}
  }
  root.addEventListener('click',e=>{
   const thumb=e.target.closest('[data-eu-gallery-thumb]');
   if(thumb){e.preventDefault();select(Number(thumb.dataset.galleryIndex));return;}
   if(e.target.closest('[data-eu-gallery-prev]')){select(current-1);return;}
   if(e.target.closest('[data-eu-gallery-next]')){select(current+1);return;}
   if(e.target.closest('[data-eu-gallery-zoom]'))openZoom();
  });
  stage.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();select(current+(e.key==='ArrowRight'?1:-1));}if(e.key==='Enter'&&root.dataset.zoom==='true')openZoom();});
  let touchX=0,touchY=0;
  stage.addEventListener('touchstart',e=>{if(root.dataset.swipe!=='true')return;touchX=e.changedTouches[0].screenX;touchY=e.changedTouches[0].screenY;},{passive:true});
  stage.addEventListener('touchend',e=>{if(root.dataset.swipe!=='true')return;const dx=e.changedTouches[0].screenX-touchX,dy=e.changedTouches[0].screenY-touchY;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.25)select(current+(dx<0?1:-1));},{passive:true});
  function openZoom(){
   if(root.dataset.zoom!=='true')return;
   const overlay=document.createElement('div');overlay.className='eu-gallery-lightbox';overlay.setAttribute('role','dialog');overlay.setAttribute('aria-modal','true');overlay.setAttribute('aria-label','Enlarged product image');
   const img=document.createElement('img');img.src=thumbs[current].dataset.galleryImage;img.alt=main.alt;
   const close=document.createElement('button');close.type='button';close.className='eu-gallery-lightbox-close';close.setAttribute('aria-label','Close enlarged image');close.textContent='×';
   overlay.append(img,close);document.body.append(overlay);const prior=document.activeElement;close.focus();
   const dismiss=()=>{overlay.remove();document.removeEventListener('keydown',onKey);prior?.focus();};
   const onKey=e=>{if(e.key==='Escape')dismiss();if(e.key==='Tab'){e.preventDefault();close.focus();}};
   document.addEventListener('keydown',onKey);overlay.addEventListener('click',e=>{if(e.target===overlay||e.target===close)dismiss();});
  }
 }
 function initialize(scope=document){scope.querySelectorAll('[data-eu-gallery]').forEach(initGallery);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize());else initialize();
 document.addEventListener('shopify:section:load',e=>initialize(e.target));
})();

/* Eunali V7: live subtotal, based on actual selected variant price in minor units. */
(function(){
 function init(section){
  const panel=section.querySelector('.eu-product-purchase');
  const box=panel?.querySelector('[data-eu-live-total]');
  const form=panel?.querySelector('[data-product-form]');
  if(!box||!form||box.dataset.initialized==='yes')return;
  box.dataset.initialized='yes';
  const currency=box.dataset.euCurrency||'USD';
  const locale=box.dataset.euLocale||'en';
  const format=cents=>{
   try{return new Intl.NumberFormat(locale,{style:'currency',currency}).format(cents/100)}
   catch(e){return (cents/100).toFixed(2)+' '+currency}
  };
  function refresh(){
   const variant=form.querySelector('input[name="id"]:checked')||form.querySelector('input[name="id"]');
   const cents=Number(variant?.dataset.euPriceCents||box.dataset.euInitialPrice||0);
   const input=form.querySelector('input[name="quantity"]');
   const qty=Math.max(1,Math.min(9999,Math.floor(Number(input?.value)||1)));
   const unit=format(cents),subtotal=format(cents*qty);
   box.querySelector('[data-eu-unit-price]').textContent=unit;
   box.querySelector('[data-eu-quantity]').textContent=String(qty);
   box.querySelector('[data-eu-subtotal]').textContent=subtotal;
   const sticky=section.querySelector('[data-eu-sticky-price]');
   if(sticky)sticky.textContent=subtotal;
   const price=panel.querySelector('[data-product-price]');
   if(price)price.textContent=unit;
  }
  form.addEventListener('input',e=>{if(e.target.matches('input[name="quantity"],input[name="id"]'))refresh()});
  form.addEventListener('change',e=>{if(e.target.matches('input[name="quantity"],input[name="id"]'))refresh()});
  // Quantity button changes dispatch a synchronous input event from the shared click handler.
  // No deferred refresh: totals update in the same click task.
  refresh();
 }
 function mount(scope=document){
  if(scope.matches?.('.eu-product-hero'))init(scope);
  scope.querySelectorAll?.('.eu-product-hero').forEach(init);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount());else mount();
 document.addEventListener('shopify:section:load',e=>mount(e.target));
})();

// Eunali V9: keep mobile navigation keyboard-accessible and close on outside click.
document.addEventListener('click',function(e){
  const nav=document.getElementById('eu-mobile-navigation');
  if(!nav)return;
  if(e.target.closest('[data-menu-toggle]')){
    nav.inert=!nav.classList.contains('open');
    return;
  }
  if(nav.classList.contains('open')&&!e.target.closest('.eu-site-header')){
    nav.classList.remove('open');nav.inert=true;
    document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded','false');
  }
});
document.addEventListener('keydown',function(e){
 if(e.key==='Escape'){
  const nav=document.getElementById('eu-mobile-navigation');
  if(nav?.classList.contains('open')){nav.classList.remove('open');nav.inert=true;document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded','false');}
 }
});

/* V10: quick-add recommended variants and edit bag quantities without navigation */
(function(){
 let busy=false;
 document.addEventListener('click',async function(event){
  const add=event.target.closest('[data-eu-cart-quick-add]');
  const change=event.target.closest('[data-eu-cart-change]');
  if(!add&&!change)return;
  event.preventDefault();
  if(busy)return;
  busy=true;
  const button=add||change,old=button.textContent;
  button.disabled=true;
  button.textContent=add?'Adding…':'…';
  try{
   const root=window.Shopify?.routes?.root||'/';
   let path,payload;
   if(add){
    const select=add.closest('.eu-cart-recommend').querySelector('[data-eu-cart-variant]');
    if(!select?.value)throw Error('Please choose an available option.');
    path='cart/add.js';payload={id:Number(select.value),quantity:1};
   }else{
    path='cart/change.js';payload={id:change.dataset.euCartChange,quantity:Number(change.dataset.euCartQty)};
   }
   const response=await fetch(root+path,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
   if(!response.ok){const error=await response.json().catch(()=>({}));throw Error(error.description||'Could not update your bag.');}
   await refreshCart();
  }catch(error){alert(error.message);}
  finally{busy=false;button.disabled=false;button.textContent=old;}
 });
})();

/* Mobile purchase bar: show only after reaching the "See Eunali in Action" section. */
(()=>{
 const bar=document.querySelector('[data-eu-sticky-buy]');
 if(!bar)return;
 const findTrigger=()=>Array.from(document.querySelectorAll('.eu-reels')).find(section=>
   /See Eunali in Action/i.test(section.querySelector('h2')?.textContent||''));
 const update=()=>{
  const trigger=findTrigger();
  const show=!!trigger && window.matchMedia('(max-width: 749px)').matches &&
    trigger.getBoundingClientRect().top<=0;
  bar.classList.toggle('eu-mobile-buy--visible',show);
  bar.setAttribute('aria-hidden',String(!show));
  if('inert' in bar)bar.inert=!show;
 };
 window.addEventListener('scroll',update,{passive:true});
 window.addEventListener('resize',update,{passive:true});
 document.addEventListener('shopify:section:load',update);
 update();
})();
